// Helper to get current origin safely (for multi-tenant support)
const getCurrentOrigin = () => {
    if (typeof window !== 'undefined' && window.location) {
        return window.location.origin;
    }
    return '';
};

export const config = {
    // Use build-time env var if set, otherwise use current domain (runtime)
    // This allows shared React builds to work for all tenants automatically
    apiUrl: process.env.REACT_APP_CLIENT_API_URL || getCurrentOrigin(),
    s3BucketUrl: process.env.REACT_APP_CLIENT_S3_BUCKET_URL || '',
    assetUrl: process.env.REACT_APP_CLIENT_ASSET_URL || '',
    altImg: "images/no_avatar_profile.jpg",
    baseUrl: (process.env.REACT_APP_CLIENT_MAIN_URL || getCurrentOrigin()) + '/',
    altInvImg: "images/inv_img.jpeg",
    mainUrl: process.env.REACT_APP_CLIENT_MAIN_URL || getCurrentOrigin(),
    pusherKey: process.env.REACT_APP_CLIENT_PUSHER_KEY || '',
    pusherCluster: process.env.REACT_APP_CLIENT_PUSHER_CLUSTER || '',
    dsn: process.env.REACT_APP_CLIENT_DSN || ''
};